import { createFileRoute } from '@tanstack/react-router'

import { AchMerchantRejectionsScreen } from './-components/ach-merchant-rejections-screen.tsx'

export const Route = createFileRoute('/ach/merchant-rejections')({
  component: AchMerchantRejectionsScreen
})
